import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

import { Link } from "react-router-dom";

import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logoDark from "../../assets/images/logo-dark.png";

const Sidebar = props => {

  return (
    <React.Fragment>
      <div className="vertical-menu" style={{backgroundColor:'#0f4f48'}}>
        <div className="navbar-brand-box" style={{backgroundColor:'rgb(255, 255, 255)'}}>
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src='/definitelogo.png' alt="" height="86" />
            </span>
            <span className="logo-lg">
              <img src='/definitelogo.png' alt="" height="86" />
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src='/definitelogo.png' alt="" height="86" />
            </span>
            <span className="logo-lg">
              <img src='/definitelogo.png' alt="" height="86" />
            </span>
          </Link>
        </div>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
